import {createPromisedAction} from '/util/action.util';
import {getRemoteConfigDefaultInstance} from '/util/remote-config/remote-config.util';

export const GET_VARIABLES: string = 'REMOTE_CONFIG/GET_VARIABLES';

export const getVariables = createPromisedAction(
  GET_VARIABLES,
  [],
  dispatchMe => {
    const remoteConfig = getRemoteConfigDefaultInstance();

    return remoteConfig
      .setDefaults()
      .then(() => remoteConfig.getAll())
      .then((vars: any) => dispatchMe(() => ({...vars})));
  },
);
